import { useHistory } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from './authConfig';
import { useIsAuthenticated } from "@azure/msal-react";
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import './components/login.css'


const Login = () => {

  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const handleLogin = (loginType) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch((e) => {
      });
    } else if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch((e) => {
      });
    }
  };

  const history = useHistory();
  const navigateTo = () => history.push('/dashboard');
  {
    return isAuthenticated ? <Redirect to="/dashboard" />
      : (
        <>
          <div className="container login-container">
            <div className='mt-5' style={{ margin: 'auto' }}>
              <img src='rivel-logo.png' width={180} />
            </div>
            <div className="mt-5 shadow-lg p-3 mb-5 bg-white rounded login-rounded">
              <div style={{ margin: "20px" }}>
                <h5>Log in to Rivel Connect</h5>
                <button className="login-button mt-4" onClick={() => handleLogin('redirect')}>
                  <img src="https://learn.microsoft.com/en-us/entra/identity-platform/media/howto-add-branding-in-apps/ms-symbollockup_mssymbol_19.svg"
                    alt="Downloadable Microsoft logo in SVG format" data-linktype="relative-path" />
                  Sign in with Microsoft</button>
              </div>
            </div>
            <footer className="footer-custom footer mt-auto py-3 bg-light">
              <div className="text-center">
                <span>© {(new Date().getFullYear())} Rivel</span>
              </div>
            </footer>
          </div>
        </>
      );
  }
};

export default Login;